(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('analyticsNew', {
            parent: 'app',
            url: '/analyticsNew',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/displays/analyticsNew/analyticsNew.html',
                    controller: 'AnalyticsNewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
